ModelLoader = require 'db/model-loader'
MemberNotificationsComponent = require './member-notifications-component'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
recup = require 'recup'
View = require 'view'
$ = require 'jquery'

module.exports = class MemberNotificationsView extends View
  className: 'member-notifications-view'

  renderOnce: ->
    @reactRoot ?= document.createElement('div')
    @$el.prepend @reactRoot
    @renderReactSection()

    @

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      @getNotificationListComponent()

  renderReactSection: ->
    ReactDOM.render @getReactRoot(), @reactRoot

    @

  getNotificationListComponent: ->
    recup.render => recup.div =>
      recup.createElement MemberNotificationsComponent, { member: @model }



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-notifications-view.coffee